import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import StylingSettings from "../components/StylingSettings/StylingSettings";
import { Redirect, useParams } from "react-router-dom";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Dialog from "@material-ui/core/Dialog";
import AuthorizationWrapper from "../components/AuthorizationWrapper";
import swal from "sweetalert";
import { _post } from "../Api";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import { getTakeawayDeliverySettings } from "../utils/ApiEndpoints";
import { setTakeawayDeliverySettings } from "../store/CloudActions";
import PostalCodes from "../components/PostalCodes/PostalCodes";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    // width: '140vh',
  },
  paper: {
    [theme.breakpoints.down("sm")]: {
      padding: "none",
    },
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
    minHeight: "40vh",
    display: "flex",
    flexDirection: "column",
  },
  openCloses: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

export default function TakeawayDeliverySettings() {
  const classes = useStyles();
  const [settings, setSettings] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [active, setActive] = React.useState(false);
  const [activeDialog, setActiveDialog] = React.useState(false);

  const [taMerchantId, setTaMerchantId] = React.useState(Number.parseInt(useParams().taMerchantId));
  const [, setTaMerchant] = React.useState(null);

  let paramTaMerchantId = Number.parseInt(useParams().taMerchantId);

  if (paramTaMerchantId !== taMerchantId) {
    setTaMerchantId(paramTaMerchantId);
    onChange();
  }

  function onChange() {
    if (cloudStore.merchant != null) {
      setTaMerchant(cloudStore.merchant.ta_merchants.find((taMerchant) => taMerchant.id === paramTaMerchantId));
      if (
        !cloudStore.takeawayDeliverySettings.deliveryHours ||
        cloudStore.takeawayDeliverySettings.deliveryHours.length === 0
      ) {
        cloudStore.takeawayDeliverySettings.deliveryHours = cloudStore.takeawayDeliverySettings.openingHours;
      }
      setSettings(cloudStore.takeawayDeliverySettings);
      setActive(cloudStore.takeawayDeliverySettings.active);
    }
  }

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChange);
    cloudStore.on(cloudStoreEvents.TAKEAWAY_DELIVERY_SETTINGS_UPDATED, onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChange);
  }, []);

  function ConditionalStyling() {
    return (
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Paper elevation={0} variant="outlined" className={classes.paper}>
          <Typography className={classes.typography} variant="h5" gutterBottom>
            Styling
          </Typography>
          <StylingSettings id={taMerchantId} settings={settings.stylingSettings} />
        </Paper>
      </Grid>
    );
  }

  const callback = (result) => {
    setTakeawayDeliverySettings(result);
    setLoading(false);
    if (!result.deliveryHours || result.deliveryHours.length === 0) {
      result.deliveryHours = result.openingHours;
    }
    setSettings(result);
    setActive(result.active);
  };

  if (loading) {
    getTakeawayDeliverySettings(taMerchantId, callback);
  }

  if (!taMerchantId) {
    return <Redirect to="/select" />;
  }

  const openCloseRestaurant = () => {
    const oldActive = active;
    setActiveDialog(false);
    _post("/nova/ta_merchant/quick/" + taMerchantId, { active: !oldActive })
      .then(() => {
        setActive(!oldActive);
      })
      .catch((e) => {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
        console.log(e);
      });
  };

  if (activeDialog) {
    return (
      <div>
        <Dialog open={activeDialog} onClose={() => setActiveDialog(false)}>
          <DialogTitle>{"Open/Close restaurant?"}</DialogTitle>
          <DialogContent>
            <DialogContentText>This will change your restaurants' open/close status.</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setActiveDialog(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={openCloseRestaurant} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  return (
    <div className={classes.div} key={taMerchantId}>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Typography variant="h4">Postal Codes - {settings.name}</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={3} className={classes.container}>
        <AuthorizationWrapper
          key={taMerchantId}
          permission={"takeaway_delivery.general_settings"}
          child={
            <Grid item lg={9} md={9} sm={12} xs={12}>
              <Paper elevation={0} variant="outlined" className={classes.paper}>
                <Typography className={classes.typography} variant="h5" gutterBottom>
                  Delivery Postal Codes
                </Typography>
                <PostalCodes />
              </Paper>
            </Grid>
          }
        />

        <AuthorizationWrapper permission={"takeaway_delivery.styling_settings"} child={<ConditionalStyling />} />
      </Grid>
    </div>
  );
}
